module.exports = __webpack_public_path__ + "img/eco-logo-white.61e1cc21.png";